import { useState } from 'react';
import { Button, Card, CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { Collapse } from 'reactstrap';
import { Search } from 'react-feather';
import { Filter } from 'Constant';
import { H5, Btn } from 'AbstractElements';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters } from 'Features/Learning/Ticket/ticketSlice';
import { fetchTicket } from '../../Ticket/TicketUtils';
import ModalAddTryout from './ModalAddTryout';
import {
  questionReportOptions,
  submateriReportOptions
} from 'Constant/ReportType';
import Select from 'react-select';

// Data tipe laporan (Soal/Submateri)
const dataType = [
  { label: 'Semua Tipe', value: '' },
  { label: 'Soal', value: 'question' },
  { label: 'Submateri', value: 'sub_material' },
];

// Mapping kategori laporan berdasarkan tipe
const categoryOptionsMap = {
  question: Object.entries(questionReportOptions).map(([value, label]) => ({ value, label })),
  sub_material: Object.entries(submateriReportOptions).map(([value, label]) => ({ value, label })),
};

const FindTicket = () => {
  const dispatch = useDispatch()
  const filters = useSelector(state => state.Ticket.filters)
  const [isFilter, setIsFilter] = useState(true);
  const [selectedValue, setSelectedValue] = useState({});
  const [openTryout, setOpenTryout] = useState(false);

  // Ambil kategori berdasarkan tipe yang dipilih
  const selectedType = filters['filter[ticketable_type]'];
  const categoryOptions = selectedType ? categoryOptionsMap[selectedType] || [] : [
    // Gabungkan semua kategori jika tipe belum dipilih
    ...Object.entries(questionReportOptions).map(([value, label]) => ({ value, label })),
    ...Object.entries(submateriReportOptions).map(([value, label]) => ({ value, label })),
  ];

  const handleClickSearch = (e) => {
    e.preventDefault()
    const newFilters = {
      ...filters,
      'page': 1,
    };
    dispatch(setFilters(newFilters));
    fetchTicket(dispatch, newFilters);
  }

  const handleResetFilter = () => {
    const newFilters = {
      ...filters,
      "filter[id]": "",
      "filter[user_id]": "",
      "filter[ticketable_id]": "",
      "filter[ticketable_type]": "",
      "filter[tryout_id]": "",
      "filter[title]": "",
      "filter[category]": "",
      "filter[is_solved]": "",
      "sort": "",
      "page": "",
    };

    dispatch(setFilters(newFilters));
    fetchTicket(dispatch, newFilters);
  }

  const updateFilters = (filters, dispatch, field, value) => {
    dispatch(setFilters({
      ...filters,
      [field]: value,
    }));
  };

  const handleSortBy = (filters, dispatch) => (e) => {
    const filterValue = e.target.value;
    updateFilters(filters, dispatch, e.target.name, filterValue);
  };

  const handleOpenTryout = () => {
    setOpenTryout(!openTryout);
  };

  return (
    <Col xl="12">
      <Card>
        <CardHeader>
          <H5 attrH5={{ className: 'mb-0' }} >
            <Btn attrBtn={{ className: 'btn btn-link ps-0', onClick: () => setIsFilter(!isFilter), color: 'transperant', datastoggle: 'collapse', databstarget: '#collapseicon', ariaexpanded: 'true', ariacontrols: 'collapseicon' }} >{'Temukan Laporan'}</Btn>
          </H5>
        </CardHeader>
        <Collapse isOpen={isFilter}>
          <div className="collapse show" id="collapseicon" aria-labelledby="collapseicon" data-parent="#accordion">
            <CardBody className="filter-cards-view animate-chk">
              <div className="job-filter">
                <div className="faq-form">
                  <Input className="form-control" type="text" placeholder="Cari laporan..."
                    value={filters['filter[title]']}
                    onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                    onChange={(e) => {
                      dispatch(setFilters({
                        ...filters,
                        'filter[title]': e.target.value
                      }));
                    }}
                  />
                  <Search className="search-icon" />
                </div>
              </div>
              <div className="checkbox-animated mt-0">
                <div className="learning-header"><span className="f-w-600">Status:</span></div>
                <Label className="d-block" htmlFor="is_solvedFalse">
                  <Input className="radio_animated" id="is_solvedFalse" type="radio" name="filter[is_solved]"
                    value="0"
                    checked={filters['filter[is_solved]'] === '0'}
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'Belum Selesai'}
                </Label>
                <Label className="d-block" htmlFor="is_solvedTrue">
                  <Input className="radio_animated" id="is_solvedTrue" type="radio" name="filter[is_solved]"
                    value="1"
                    checked={filters['filter[is_solved]'] === '1'}
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'Selesai'}
                </Label>
              </div>
              <div className="checkbox-animated mt-0">
                <div className="learning-header"><span className="f-w-600">Sort by:</span></div>
                <Label className="d-block" htmlFor="sort-new">
                  <Input className="radio_animated" id="sort-new" type="radio" name="sort"
                    checked={filters.sort === '-id'}
                    value="-id"
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'Terbaru'}
                </Label>
                <Label className="d-block" htmlFor="sort-old">
                  <Input className="radio_animated" id="sort-old" type="radio" name="sort"
                    checked={filters.sort === 'id'}
                    value="id"
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'Terlama'}
                </Label>
                <Label className="d-block" htmlFor="sort-az">
                  <Input className="radio_animated" id="sort-az" type="radio" name="sort"
                    checked={filters.sort === 'title'}
                    value="title"
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'A-Z'}
                </Label>
                <Label className="d-block" htmlFor="sort-za">
                  <Input className="radio_animated" id="sort-za" type="radio" name="sort"
                    checked={filters.sort === '-title'}
                    value="-title"
                    onChange={handleSortBy(filters, dispatch)}
                  />
                  {'Z-A'}
                </Label>
              </div>
              <div className="checkbox-animated mt-0">
                <div className="learning-header">
                  <span className="f-w-600">Tipe Laporan:</span>
                </div>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  placeholder="Pilih Tipe..."
                  isClearable={filters['filter[ticketable_type]'] !== ''}
                  isSearchable
                  name="filter[category]"
                  options={dataType}
                  onChange={(selected) => {
                    dispatch(setFilters({
                      ...filters,
                      'filter[ticketable_type]': selected ? selected.value : '',
                      'filter[category]': '',
                    }));
                  }}
                  value={dataType.find(opt => opt.value === filters['filter[ticketable_type]']) || null}
                />
              </div>
              {
                selectedType && categoryOptions.length > 0 &&
                <div className="checkbox-animated mt-0">
                  <div className="learning-header">
                    <span className="f-w-600">Kategori Laporan:</span>
                  </div>
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    placeholder="Pilih Kategori Laporan..."
                    isClearable={filters['filter[category]'] !== ''}
                    isSearchable
                    name="filter[category]"
                    options={selectedType ? categoryOptions : []} // hanya tampilkan jika tipe sudah dipilih
                    onChange={(selected) => {
                      dispatch(setFilters({
                        ...filters,
                        'filter[category]': selected ? selected.value : ''
                      }));
                    }}
                    value={categoryOptions.find(opt => opt.value === filters['filter[category]']) || null}
                  />
                </div>
              }
              <div className="checkbox-animated mt-0">
                <Label style={{ display: 'block' }}>
                  Pilih Tryout :
                  <Button color={Object.keys(selectedValue).length > 0 ? 'success' : 'primary'} style={{ display: "block", marginBottom: "20px" }} onClick={handleOpenTryout}>{Object.keys(selectedValue).length > 0 ? "Edit" : 'Pilih'} Tryout</Button>
                </Label>
                <ModalAddTryout openTryout={openTryout} handleOpenTryout={handleOpenTryout} selectedValue={selectedValue} setSelectedValue={setSelectedValue} />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'primary text-center p-1', onClick: handleClickSearch }}>{Filter}</Btn>
                </div>
                <div className="col-md-6">
                  <Btn attrBtn={{ color: 'warning text-center p-1', onClick: handleResetFilter }}>{'Reset'}</Btn>
                </div>
              </div>
            </CardBody>
          </div>
        </Collapse>
      </Card>
    </Col>
  );
};

export default FindTicket;